import { SET_LOCALIZATION_LANGS_SUCCESS } from './constants';
import en from './languages/english';

const localizationState = {
    lang: 'en',
    content: en
};

/**
 *
 * @param state
 * @param action
 * @returns {{lang: string, content}|{lang: langsReducer, content}}
 */
const localization = ( state = localizationState, action ) => {
    switch ( action.type ) {
        case SET_LOCALIZATION_LANGS_SUCCESS: {
            return { lang: action.langs, content: { ...action.content } };
        }
        default:
            return state;
    }
};

export default localization;